import { Link } from "react-router-dom";
import ServicesHeadingImage from "../../images/services/services-heading-image.png";
import IntegrationBg from "../../images/services/integration-bg.png";
import SearchIcon from "../../images/services/search.png";
import HR from "../../images/services/hr.png";

function ServicesMain() {
  return (
    <div className="services-main">
      <div className="heading">
        <img src={ServicesHeadingImage} alt="heading" />
        <h1>Our Services</h1>
        <p>
          Over the years, we've built a range of tools to solve real problems —
          tools that help teams work better, manage faster, and stay in control.
          These 11 products weren't built for show — they were built because
          someone needed them.
        </p>
      </div>
      <div className="services">
        <div className="integration">
          <img src={IntegrationBg} alt="bg" className="bg" />
          <div className="content">
            <h1>Integration Services</h1>
            <p>
              We handle end-to-end IT and telecom projects — from software
              delivery to hardware integration. Our team combines deep expertise
              with modern tools, ensuring every solution is tested, secure, and
              ready to perform.We handle end-to-end IT and telecom projects —
              from software delivery to hardware integration. Our team combines
              deep expertise with modern tools, ensuring every solution is
              tested, secure, and ready to perform.
            </p>
            <Link to="/contact-us">
              <div className="link">
                <h2>Contact us</h2>
                <div />
              </div>
            </Link>
          </div>
        </div>
        <div className="managing">
          <div className="service1">
            <h1>Outsourcing - Managing Services</h1>
            <h2>
              We provide managed services and IT outsourcing, from application
              support to hosting. We deliver across all support levels, using
              proven methods to keep systems running smoothly.
            </h2>
            <Link to="/contact-us">
              <div className="link">
                <p>Contact us</p>
                <div />
              </div>
            </Link>
          </div>
          <div className="service2">
            <img src={SearchIcon} alt="search" />
            <h1>Research & Development</h1>
            <h2>
              BrandOne Technologies explores forward-thinking solutions across
              key tech domains. Our current R&D areas include: e-Solutions |
              Human- Computer Interaction | Document Management System |
              Government Platforms | ICT & Policy | Web Technologies |
              Cybersecurity | Open Source | Semantic & Intelligent Systems |
              Emerging Tech
            </h2>
            <Link to="/contact-us">
              <div className="link">
                <p>Contact us</p>
                <div />
              </div>
            </Link>
          </div>
        </div>
        <div className="hr">
          <img src={HR} alt="bg" className="bg-image" />
          <h1>Human Resources</h1>
          <h2>
            At BrandOne Technologies, we believe great teams build great
            solutions. Our HR services focus on attracting and nurturing smart,
            adaptable professionals who thrive on challenge and change. We
            recruit talent from diverse backgrounds, fostering a multicultural
            environment that drives collaboration and innovation. With clear
            growth paths and strong support, we ensure every team member is set
            up for success.
          </h2>
          <Link to="/contact-us">
            <div className="link">
              <p>Contact us</p>
              <div />
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ServicesMain;
